import Modal from "../../designComponents/Modal";
import {
  AcceptButton,
  LabelText,
  SectionTitle,
} from "../Properties/Details/styles";
import { Input, InputGroup } from "./styles";

export interface PricingSettings {
  perDayRate: number;
  weeklyDiscountRate: number;
  monthlyDiscountRate: number;
  currency: "EUR";
  flatFee: number;
  percentageFee: number;
  stripeFeePercentage: number;
  stripeFeeRate: number;
  verificationFlatFee?: number;
  verificationPercentageFee?: number;
  lookupFlatFee?: number;
  lookupPercentageFee?: number;
  rentisityFlatFee?: number;
}
function AddStripeVerification({
  isOpen,
  onClose,
  onAddPress,
  setData,
  initialValues,
}: {
  isOpen: boolean;
  onClose: () => void;
  onAddPress: () => void;
  setData: React.Dispatch<React.SetStateAction<PricingSettings>>;
  initialValues: PricingSettings;
}) {
  const handleChange = (field: keyof PricingSettings, value: string) => {
    const numValue = parseFloat(value) || 0;
    setData((prev) => ({
      ...prev,
      [field]: numValue,
    }));
  };
  return (
    <Modal
      isOpen={isOpen}
      halfWidth={true}
      onClose={onClose}
      title="Add Stripe Fee"
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <SectionTitle>Stripe Verification Fees</SectionTitle>
          <InputGroup>
            <LabelText>VerificationPercentage Fee (%)</LabelText>
            <Input
              type="number"
              value={initialValues.verificationPercentageFee}
              onChange={(e) =>
                handleChange("verificationPercentageFee", e.target.value)
              }
              placeholder="Enter per day rate"
            />
          </InputGroup>

          <InputGroup>
            <LabelText>Verification Flat Fee(€)</LabelText>
            <Input
              type="number"
              value={initialValues.verificationFlatFee}
              onChange={(e) =>
                handleChange("verificationFlatFee", e.target.value)
              }
              placeholder="Enter weekly discount"
              min="0"
              max="100"
            />
          </InputGroup>
        </div>
      </div>
      <div>
        <SectionTitle>Verification Lookup Fees</SectionTitle>
        <InputGroup>
          <LabelText>Lookup Flat Fee (€)</LabelText>
          <Input
            type="number"
            value={initialValues.lookupFlatFee}
            onChange={(e) => handleChange("lookupFlatFee", e.target.value)}
            placeholder="Enter per day rate"
          />
        </InputGroup>
        <InputGroup>
          <LabelText>Lookup Percentage Fee (%)</LabelText>
          <Input
            type="number"
            value={initialValues.lookupPercentageFee}
            onChange={(e) =>
              handleChange("lookupPercentageFee", e.target.value)
            }
            placeholder="Enter per day rate"
          />
        </InputGroup>
        <SectionTitle>Rentisity Flat Fee</SectionTitle>
        <InputGroup>
          <LabelText>Platform Flat Fee (%)</LabelText>
          <Input
            type="number"
            value={initialValues.rentisityFlatFee}
            onChange={(e) => handleChange("rentisityFlatFee", e.target.value)}
            placeholder="Enter per day rate"
          />
        </InputGroup>
      </div>
      <AcceptButton onClick={onAddPress}>Save</AcceptButton>
    </Modal>
  );
}

export default AddStripeVerification;
